export const BUSINESS_CATEGORY = [
  {
    label: 'Pakaian & Aksesoris',
  },
  {
    label: 'Kecantikan & Perawatan Pribadi',
  },
  {
    label: 'Rumah & Taman',
  },
  {
    label: 'Makanan & Minuman',
  },
  {
    label: 'Kesehatan & Kebugran',
  },
  {
    label: 'Buku, Music & Media',
  },
  {
    label: 'Olahraga & Luar Ruangan',
  },
  {
    label: 'Mainan & Hobi',
  },
  {
    label: 'Seni & Kerajinan',
  },
  {
    label: 'Otomatif & Industri',
  },
  {
    label: 'Perlengkapan Hewat Peliharaan',
  },
  {
    label: 'Hadiah & Barang Khusus',
  },
  {
    label: 'Berkelanjutan & Ramah Lingkungan',
  },
  {
    label: 'Barang Antik & Koleksi',
  },
];

export const CHANNELS = [
  {
    channel_name: 'JUBELIO STORE',
    channel_id: 131072,
  },
];

export const RESTRICT_AGE = {
  title: 'PERIKSA UMUR ANDA',
  description:
    'Website ini berisi produk yang ditujukan hanya untuk individu yang berusia 21 tahun ke atas. Dengan ini Saya menyatakan bahwa saya telah memenuhi kualifikasi umur yang disarankan. Apakah kamu berusia 21 tahun ke atas?',
  age: 21,
  confirm_label: 'SAYA BERUMUR',
  cancel_label: 'SAYA BELUM',
  is_active: false,
  confirm_button_background_color: '#000000',
  confirm_label_text_color: '#FFFFFF',
  cancel_button_background_color: '#FFFFFF',
  cancel_label_text_color: '#000000',
};

export const SORTING_QUERY = [
  {
    label: 'Best selling',
    value: 'best-selling',
    sortBy: 'best_selling',
    sortDirection: 'DESC',
  },
  {
    label: 'Alphabetically, A-Z',
    value: 'title-ascending',
    sortBy: 'product_name',
    sortDirection: 'ASC',
  },
  {
    label: 'Alphabetically, Z-A',
    value: 'title-descending',
    sortBy: 'product_name',
    sortDirection: 'DESC',
  },
  {
    label: 'Price, low to high',
    value: 'price-ascending',
    sortBy: 'sell_price',
    sortDirection: 'ASC',
  },
  {
    label: 'Price, high to low',
    value: 'price-descending',
    sortBy: 'sell_price',
    sortDirection: 'DESC',
  },
  {
    label: 'Date, old to new',
    value: 'created-ascending',
    sortBy: 'modified_at',
    sortDirection: 'ASC',
  },
  {
    label: 'Date, new to old',
    value: 'created-descending',
    sortBy: 'modified_at',
    sortDirection: 'DESC',
  },
  {
    label: 'Rating, low to high',
    value: 'rating-ascending',
    sortBy: 'rating_average',
    sortDirection: 'ASC',
  },
  {
    label: 'Rating, high to low',
    value: 'rating-descending',
    sortBy: 'rating_average',
    sortDirection: 'DESC',
  },
];

export const AVAILABILITY_OPTIONS = [
  { id: 'in-stock', label: 'In stock', value: '1' },
  { id: 'out-stock', label: 'Out of stock', value: '0' },
];

export const TAX_APPLICATION_OPTIONS = [
  { label: 'Tax Included', value: 'tax_included' },
  { label: 'Tax Excluded', value: 'tax_excluded' },
  { label: 'No Tax', value: 'no_tax' },
] as const;

export const TAX_PERCENTAGE_OPTIONS = [
  { label: 'No Tax', value: 0 },
  { label: '10%', value: 10 },
  { label: '11%', value: 11 },
] as const;

export const ORDER_EXPIRY_TIME = {
  FIFTEEN_MINUTES: 900,
  THIRTY_MINUTES: 1800,
  ONE_HOUR: 3600,
  TWO_HOURS: 7200,
  SIX_HOURS: 21600,
  TWELVE_HOURS: 43200,
  TWENTY_FOUR_HOURS: 86400,
  TWO_DAYS: 172800,
  THREE_DAYS: 259200,
} as const;

export const ORDER_EXPIRY_TIME_OPTIONS = [
  { label: '15 minutes', value: ORDER_EXPIRY_TIME.FIFTEEN_MINUTES },
  { label: '30 minutes', value: ORDER_EXPIRY_TIME.THIRTY_MINUTES },
  { label: '1 hour', value: ORDER_EXPIRY_TIME.ONE_HOUR },
  { label: '2 hours', value: ORDER_EXPIRY_TIME.TWO_HOURS },
  { label: '6 hours', value: ORDER_EXPIRY_TIME.SIX_HOURS },
  { label: '12 hours', value: ORDER_EXPIRY_TIME.TWELVE_HOURS },
  { label: '24 hours', value: ORDER_EXPIRY_TIME.TWENTY_FOUR_HOURS },
  { label: '2 days', value: ORDER_EXPIRY_TIME.TWO_DAYS },
  { label: '3 days', value: ORDER_EXPIRY_TIME.THREE_DAYS },
] as const;

export const PICKUP_MINIMUM_PREPARATION_OPTIONS = [
  { label: '30 Minutes', value: '30' },
  { label: '1 Hour', value: '60' },
  { label: '2 Hours', value: '120' },
  { label: '4 Hours', value: '240' },
  { label: '6 Hours', value: '360' },
  // { label: '8 Hours', value: '480' },
  // { label: '12 Hours', value: '720' },
  // { label: '24 Hours', value: '1440' },
] as const;

export const PICKUP_VERIFICATION_METHOD_OPTIONS = [
  { label: 'QR Code', value: 'qr_code' },
  // { label: 'Barcode', value: 'barcode' },
  // { label: 'PIN', value: 'pin' },
] as const;

export const PICKUP_NOTIFICATION_OPTIONS = [
  { label: 'Email', value: 'email' },
  // { label: 'WhatsApp', value: 'whatsapp' },
  // { label: 'Both', value: 'both' },
] as const;

export const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
